import React from 'react'
import { ErrorLayout } from '../../components'

const Error403 = () => {
  return (
    <ErrorLayout title="You do not have access to this">
      <svg
        width="212"
        height="214"
        viewBox="0 0 212 214"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.3"
          d="M68.7922 208.485C83.6489 217.44 94.2476 213.722 98.3052 206.542C106.152 192.655 132.242 164.258 173.588 154.66C228.348 141.948 216.912 108.196 183.249 90.4842C149.586 72.7725 124.415 48.2651 128.225 21.6176C132.034 -5.02983 94.2889 -14.2161 77.5029 37.0447C66.6554 70.1713 47.216 79.0461 34.8198 81.1794C23.1367 83.1899 10.3568 85.7126 4.12469 95.7971C-3.43755 108.033 -0.798692 120.41 30.8627 128.9C75.7301 140.93 35.492 188.413 68.7922 208.485Z"
          fill="#DFF6F0"
        />
        <path
          d="M30.1915 150.424C30.8202 150.064 37.9166 147.06 73.2195 163.518C73.1166 163.658 73.0729 163.724 73.0729 163.724C73.0729 163.724 36.3721 176.084 29.1813 160.857C27.0339 156.324 27.6492 153.203 30.1302 150.459L30.1915 150.424Z"
          fill="#2E279D"
        />
        <path
          d="M148.847 156.652C141.177 163.1 129.149 167.78 117.543 161.557C119.377 160.385 121.271 159.178 123.203 157.929C134.859 150.44 145.125 155.451 148.847 156.652Z"
          fill="#2E279D"
        />
        <path
          d="M162.586 77.3485C170.422 142.6 151.799 154.443 149.726 156.242C149.126 156.763 148.883 156.725 147.975 156.491L147.96 156.5C144.119 155.482 134.859 150.44 123.203 157.928C121.271 159.176 119.377 160.384 117.543 161.555C105.653 169.096 96.0512 174.411 89.1336 171.326C83.2661 168.333 77.9756 165.743 73.2194 163.518C37.9165 147.059 30.8201 150.064 30.1914 150.424C30.9209 150.026 37.6134 146.317 46.6246 139.793C46.6553 139.775 46.6859 139.758 46.6925 139.734C58.7373 131.005 74.8676 117.249 86.4622 99.5538C94.3552 87.5211 102.077 57.0168 116.976 51.0315C147.595 39.6089 161.314 64.076 162.586 77.3485Z"
          fill="#46B3E6"
        />
        <path
          d="M128.729 76.204C129.68 73.6942 129.587 71.3328 128.522 70.9295C127.457 70.5263 125.824 72.234 124.873 74.7438C123.923 77.2535 124.015 79.615 125.08 80.0182C126.145 80.4214 127.779 78.7137 128.729 76.204Z"
          fill="#DFF6F0"
        />
        <path
          d="M148.224 79.4063C148.898 76.8085 148.551 74.4709 147.449 74.1851C146.346 73.8993 144.907 75.7736 144.233 78.3714C143.56 80.9693 143.907 83.3069 145.009 83.5926C146.111 83.8784 147.551 82.0041 148.224 79.4063Z"
          fill="#DFF6F0"
        />
        <path
          d="M136.357 88.9445C136.198 88.9443 136.043 88.8895 135.919 88.7893C135.794 88.689 135.708 88.5492 135.674 88.3931C135.549 87.8281 134.994 86.1562 134.114 85.9077C133.233 85.6592 131.507 86.624 130.808 87.1301C130.658 87.239 130.47 87.2837 130.287 87.2544C130.103 87.225 129.939 87.1241 129.83 86.9737C129.721 86.8233 129.677 86.6358 129.706 86.4525C129.735 86.2692 129.836 86.105 129.987 85.9961C130.262 85.7967 132.728 84.062 134.494 84.5602C136.336 85.0799 136.975 87.7882 137.042 88.0954C137.064 88.1976 137.063 88.3036 137.039 88.4054C137.015 88.5073 136.969 88.6024 136.903 88.6839C136.837 88.7654 136.754 88.831 136.66 88.8761C136.565 88.9212 136.462 88.9446 136.357 88.9445H136.357Z"
          fill="#DFF6F0"
        />
      </svg>
    </ErrorLayout>
  )
}

export { Error403 }
